import styled from 'styled-components';
import { GRAY_100 } from '../../core/colors';
import SvgCross from '../../others/svg_dist/Cross';

export const Wrapper = styled.div`
	cursor: text;
	border: 3px solid ${GRAY_100};
	width: 70%;
	margin: 10px auto;
	height: 65px;
	position: relative;
	@media screen and (max-width: 550px) {
		width: 85%;
	}
	@media screen and (max-height: 850px) {
		height: 55px;
	}
`;

export const Input = styled.input`
	all: unset;
	width: calc(100% - 40px);
	color: #000;
	height: 55px;
	padding: 0 20px;
	font-size: 20px;
	&::placeholder {
		color: #909090;
	}
	@media screen and (max-height: 850px) {
		height: 45px;
		font-size: 17px;
	}
`;

export const StyledX = styled(SvgCross)`
	fill: #d12f2f;
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	user-select: none;
	cursor: pointer;
`;
